export default function OperatorsIcon(props) {
	return (
		<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.2929 12.8858C12.8052 13.8909 14.6542 16.2108 15 19H0C0.345805 16.2108 2.19482 13.8909 4.70711 12.8858L7.5 17.1L10.2929 12.8858ZM13.1689 0V5.7C13.1689 8.8483 10.6311 11.4 7.5 11.4C4.36886 11.4 1.83107 8.8483 1.83107 5.7V0H13.1689ZM11.2793 5.7H3.72071C3.72071 7.7995 5.41194 9.5 7.5 9.5C9.58806 9.5 11.2793 7.7995 11.2793 5.7Z"
				fill="currentColor"
			/>
		</svg>
	);
}
